<template>
    <div>
        <h3>¿Tienes un cupón de descuento?</h3>

        <div class="input-group">
            <input
                data-cy="cupon-input"
                class="form-control w-auto"
                id="input-voucher"
                v-model="code"
                :placeholder="$t('formularios.cupon_descuento')"
                :disabled="(message && !error) || desactivar || loading || loading_check"
            />
            <button
                v-if="message && !error"
                data-cy="cupon-quitar"
                :disabled="desactivar || loading || loading_check"
                class="button large-button"
                @click="remove"
            >{{ $t('formularios.quitar')}}</button>
            <button
                v-else
                data-cy="cupon-verificar"
                :disabled="desactivar || loading || loading_check || !code"
                class="button large-button"
                @click="check"
            >{{ $t('formularios.verificar')}}</button>
        </div>

        <input class="form-control is-invalid" hidden />
        <span
            data-cy="cupon-mensaje"
            :class="{error: true, 'bg-success': !error}"
            v-if="message"
        >{{ message }}</span>
    </div>
</template>

<script>
    export default {
        props: ['event_id', "event_session_id", "cart_session_id", "desactivar", "loading"],
        data() {
            return {
                code: "",
                error: null,
                message: null,
                voucher: {},
                loading_check: false
            }
        },
        methods: {
            async check() {
                this.loading_check = true;

                const params = { 
                    filters: { 
                        sesion_id: this.event_session_id,
                        cart_session_id: this.cart_session_id,
                        code: this.code,
                    },
                    event_id: this.event_id,
                };

                try {
                    const res = await this.$store.dispatch(this.config.getVuexAlias('front.voucher.bloquear'), params)
                    this.message = res.data.message;
                    this.voucher = res.data.voucher;
                    this.error = false;
                } catch(error) {
                    this.message = error.response.data.message;
                    this.error = true;
                }

                this.loading_check = false;

                if(!this.error)
                    this.$emit('validated', this.voucher);
            },
            async remove() {
                this.code = "";
                this.error = null,
                this.message = null;
                this.voucher = {};

                const params = { 
                    filters: { 
                        sesion_id: this.event_session_id,
                        cart_session_id: this.cart_session_id,
                    },
                    event_id: this.event_id,
                };

                const res = await this.$store.dispatch(this.config.getVuexAlias('front.voucher.desbloquear'), params)
                this.$emit('validated', null);

            }
        },
    }
</script>